<template>
  <button
    class=" bg-black text-white font-bold py-20-px  w-full lg:w-80"
    :class="btnStyle"
    @click="onClickEmit"
    v-text="text"
  />
</template>
<script>
export default {
    props:{
        text: {
            default: 'Boton principal'
        },
        btnStyle:{
          default: 'rounded-xl text-lg',
        },
        isDisabled:{
          default:false,
        }
    },
    methods:{
      onClickEmit(){
        if(!this.isDisabled) this.$emit("click")
      }
    }
}
</script>
